import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "¿Es gratis usar Senda de Vida?", a: "Sí, tenemos un plan gratuito con acceso a contenido seleccionado. También ofrecemos planes de suscripción para acceso completo." },
  { q: "¿Puedo escuchar sin conexión a internet?", a: "Con los planes de pago puedes descargar audiolibros para escuchar sin conexión." },
  { q: "¿Qué tipo de contenido tienen?", a: "Ofrecemos clásicos de la fe cristiana en formato de audiolibro con narración profesional, y también libros completos en PDF." },
  { q: "¿Puedo usar la app en mi celular?", a: "Sí, nuestra plataforma es totalmente responsiva y funciona en cualquier dispositivo con navegador web." },
  { q: "¿Cómo se selecciona el contenido?", a: "Nuestro equipo editorial selecciona obras clásicas y contemporáneas de reconocido valor espiritual y teológico." },
];

export function FAQ() {
  return (
    <section id="faq" className="py-24">
      <div className="container mx-auto px-4 max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-12">
          Preguntas frecuentes
        </h2>

        <Accordion type="single" collapsible>
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-foreground">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
